import { useState } from 'react';
import { ACTIVE_URL } from '@/constants';
import SpotlightCard from '@/components/SpotlightCard';
import GlassSurface from '@/components/GlassSurface';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';

const inputClass = "bg-white/5 border-white/10 text-white placeholder:text-white/40 focus-visible:border-[#00d9d9] focus-visible:ring-[#00d9d9]/20 h-12 rounded-lg";

export function ContactForm() {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  async function handleSubmit(e: React.SyntheticEvent<HTMLFormElement>) {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    setLoading(true);
    await fetch(`${ACTIVE_URL}/api/contact/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',  
      },
      body: JSON.stringify({
        name: data.get('name'),
        email: data.get('email'),
        phone: data.get('phone'),
        subject: data.get('subject'),
        message: data.get('message'),
      }),
    });
    setLoading(false);
    setSubmitted(true);
  }

  if (submitted) {
    return (
      <SpotlightCard spotlightColor="rgba(0, 229, 255, 0.2)" className="flex flex-col gap-4">
        <div className="flex flex-col items-center justify-center gap-4 py-12 text-center">
          <p className="text-2xl font-bold text-white">Το μήνυμά σου στάλθηκε!</p>
          <p className="text-white/60">Θα επικοινωνήσουμε μαζί σου σύντομα.</p>
          <button
            onClick={() => setSubmitted(false)}
            className="mt-4 text-[#00d9d9] underline underline-offset-4 hover:opacity-70 transition-opacity text-sm"
          >
            Αποστολή νέου μηνύματος
          </button>
        </div>
      </SpotlightCard>
    );
  }

  return (
    <SpotlightCard spotlightColor="rgba(0, 229, 255, 0.2)" className="flex flex-col gap-4">
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <Input name="name" type="text" placeholder="Το όνομά σου" required className={inputClass} />
        <Input name="email" type="email" placeholder="Το email σου*" required className={inputClass} />
        <Input name="phone" type="tel" placeholder="Το κινητό σου*" required className={inputClass} />
        <Input name="subject" type="text" placeholder="Θέμα" required className={inputClass} />
        <Textarea
          name="message"
          placeholder="Μήνυμα"
          rows={5}
          required
          className="bg-white/5 border-white/10 text-white placeholder:text-white/40 focus-visible:border-[#00d9d9] focus-visible:ring-[#00d9d9]/20 rounded-lg resize-none"
        />
        <div className="mt-2">
          <button type="submit" disabled={loading} className="w-full cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed">
            <GlassSurface
              className="w-full hover:scale-[1.02] transform transition-all duration-200"
              displace={0.1}
              distortionScale={100}
              redOffset={0}
              greenOffset={10}
              blueOffset={20}
              brightness={100}
              opacity={0.09}
              mixBlendMode="screen"
              borderRadius={10}
              width="100%"
              height={52}
            >
              <span className="text-lg text-white px-2 py-0 w-full text-center block">
                {loading ? 'Αποστολή...' : 'Αποστολή'}
              </span>
            </GlassSurface>
          </button>
        </div>
      </form>
    </SpotlightCard>
  );
}
